import MenuComponent from '@/components/MenuComponent'
import BlocAuthenticated from '@/components/BlocAuthenticated'

export default {
  components: {
    MenuComponent,
    BlocAuthenticated
  },
  data () {
    return {
      roles: [],
      loading: false
    }
  },
  methods: {
    async getRoles () {
      this.loading = true
      this.$store.dispatch('user/getRoles').then(
        response => {
          this.loading = false
          this.roles = response
        },
        error => {
          this.loading = false
          this.errorMessage = error.response.data
        }
      )
    }
  },
  created () {
    if (!this.roles.length) {
      this.getRoles()
    }
  },
  beforeCreate () {
    this.$store.state.filArianePage = 'Liste des roles'
    this.$store.state.filArianeMiddlePage = null
    this.$store.state.filArianeMiddleRouterLink = null
  }
}
